import { browserTracingIntegration, init, replayIntegration } from '@sentry/react';

const CONSENT_KEY = 'optiro-analytics-consent';

export function initSentry() {
  if (!import.meta.env.VITE_SENTRY_DSN) return;

  init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [browserTracingIntegration()],
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    tracePropagationTargets: [/^https:\/\/api\.optiro\.dk/],
    sendDefaultPii: false,
  });
}

export function initSentryReplay() {
  import('@sentry/react').then(({ getClient }) => {
    getClient()?.addIntegration(
      replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      })
    );
  });
}

export function hasSentryReplayConsent() {
  return window.localStorage.getItem(CONSENT_KEY) === 'granted';
}
